<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <router-view></router-view>
    <!-- 固定 -->
    <scrollTop ref="scrollTopRef"></scrollTop>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import scrollTop from './components/ScrollTop.vue'
export default {
  name: 'App',
  data() {
    return {
      scrollTop: 0,
      toTopShow: false,
    }
  },
  components: {
    scrollTop,
  },
  watch: {
    $route(to, from) {
      console.log(to)
      this.$nextTick(()=>{
        this.$refs.scrollTopRef.scrollToTop()
      })
    },
    immediate: true,
    deep: true,
  },

  created() {
    // this.$store.dispatch('getUserDetails')
  },
}
</script>

<style>
@font-face {
  font-family: 'Prompt';
  src: url('@/assets/fonts/prompt-1.ttf') format('truetype');
}

@font-face {
  font-family: 'MonaSemiBold';
  src: url('@/assets/fonts/Mona-SemiBold-2.ttf') format('truetype');
}
#app {
  font-size: 14px;
  margin: 0;
  padding: 0;
  -ms-overflow-style: none;
  /* IE和Edge */
  scrollbar-width: none;
  /* Firefox */
  font-family: Prompt, sans-serif;
}
</style>
